import { render, staticRenderFns } from "./plugin-procedure.vue?vue&type=template&id=3efde64b&scoped=true&"
import script from "./plugin-procedure.vue?vue&type=script&lang=js&"
export * from "./plugin-procedure.vue?vue&type=script&lang=js&"
import style0 from "./plugin-procedure.vue?vue&type=style&index=0&id=3efde64b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efde64b",
  null
  
)

export default component.exports